<div class="grid-container">
  <div class="grid-row grid-gap-1">
    <h2>{{getDashboardTitle(dashboardName)}}</h2>
  </div>
  <div class="grid-row grid-gap-1">
    <tableau-viz id='tableauViz'  toolbar='hidden'>
      <viz-parameter id="accessIdParm" name="AccessID"/>
    </tableau-viz>
  </div>
</div>
